<template>
  <div class="mt-4">
    <v-card class="mx-auto" max-width="95%" elevation="2">
      <v-toolbar dark>
        <v-toolbar-title>프롬북 · 유저 구매내역</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip small outlined dark class="mr-2">총 {{ total.toLocaleString() }}건</v-chip>
      </v-toolbar>

      <!-- 필터 영역 -->
      <v-card-text class="pb-0">
        <v-row dense align="center">
          <v-col cols="12" sm="2">
            <v-text-field
              v-model="filter.user_id"
              label="유저 ID"
              outlined dense hide-details clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
              v-model="filter.prd_id"
              label="상품 ID (prd_id)"
              outlined dense hide-details clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-select
              v-model="filter.process_state"
              :items="stateOptions"
              label="상태"
              outlined dense hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
              v-model="filter.start_date"
              label="시작일 (YYYY-MM-DD)"
              outlined dense hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
              v-model="filter.end_date"
              label="종료일 (YYYY-MM-DD)"
              outlined dense hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1">
            <v-btn color="primary" depressed block @click="onSearch">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- 구매내역 리스트 -->
      <v-card-text class="pa-0 pt-2">
        <div style="overflow-x: auto;">
          <v-data-table
            :headers="headers"
            :items="list"
            :items-per-page="50"
            :footer-props="{'items-per-page-options':[50, 100, 200]}"
            :loading="loading"
            :server-items-length="total"
            class="elevation-0"
          >
            <template v-slot:item.sale_price="{ item }">
              {{ (item.sale_price || 0).toLocaleString() }}원
            </template>
            <template v-slot:item.point_price="{ item }">
              {{ (item.point_price || 0).toLocaleString() }}P
            </template>
            <template v-slot:item.process_state="{ item }">
              <v-chip x-small :color="stateColor(item.process_state)" dark>
                {{ item.process_state }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn icon small @click="openDetail(item)" title="상세보기">
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
        <v-container v-if="!loading && list.length === 0" class="text-center py-8">
          <v-icon size="56" color="grey lighten-1">mdi-cart-off</v-icon>
          <p class="text-body-1 grey--text mt-3">검색 결과가 없습니다.</p>
        </v-container>
      </v-card-text>
    </v-card>

    <!-- 상세 다이얼로그 -->
    <v-dialog v-model="dialog" max-width="640" scrollable>
      <v-card>
        <v-card-title>
          <v-icon left>mdi-receipt</v-icon>
          구매 상세
          <v-spacer></v-spacer>
          <v-chip small outlined>{{ selected.id }}</v-chip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-simple-table dense>
            <tbody>
              <tr><td class="font-weight-bold" style="width:140px">구매 ID</td><td>{{ selected.id }}</td></tr>
              <tr><td class="font-weight-bold">유저 ID</td><td>{{ selected.user_id }}</td></tr>
              <tr><td class="font-weight-bold">상품 ID</td><td>{{ selected.prd_id }}</td></tr>
              <tr><td class="font-weight-bold">상품명</td><td>{{ selected.prd_nm }}</td></tr>
              <tr><td class="font-weight-bold">교환처</td><td>{{ selected.swap_nm }}</td></tr>
              <tr><td class="font-weight-bold">유형</td><td>{{ selected.tr_type }}</td></tr>
              <tr><td class="font-weight-bold">판매가 / 수수료</td><td>{{ (selected.sale_price || 0).toLocaleString() }}원 / {{ (selected.pub_cms || 0).toLocaleString() }}원</td></tr>
              <tr><td class="font-weight-bold">사용 포인트</td><td>{{ (selected.point_price || 0).toLocaleString() }}P</td></tr>
              <tr><td class="font-weight-bold">쿠폰번호 (pin)</td><td>{{ selected.pin_no }}</td></tr>
              <tr><td class="font-weight-bold">거래번호</td><td>tr: {{ selected.tr_id }} / str: {{ selected.str_tr_id }}</td></tr>
              <tr><td class="font-weight-bold">만료</td><td>{{ selected.expr_dt }}</td></tr>
              <tr><td class="font-weight-bold">상태</td>
                <td><v-chip x-small :color="stateColor(selected.process_state)" dark>{{ selected.process_state }}</v-chip></td>
              </tr>
              <tr><td class="font-weight-bold">구매일</td><td>{{ selected.created_at }}</td></tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <!-- TODO: 취소(reqstat/취소 API) 연동 시 구현 -->
          <v-btn small color="orange" dark disabled>
            <v-icon left small>mdi-cash-refund</v-icon>취소 (미구현)
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="py-12"></div>
  </div>
</template>

<script>
import { prombook } from '../../api'

export default {
  name: 'Prombook_BuyProductList',
  data() {
    return {
      loading: false,
      total: 0,
      list: [],
      filter: {
        user_id: '',
        prd_id: '',
        process_state: null,
        start_date: '',
        end_date: '',
        page: 1,
        page_size: 50,
      },
      dialog: false,
      selected: {},
      stateOptions: [
        { text: '전체', value: null },
        { text: 'DONE', value: 'DONE' },
        { text: 'DELIVERING', value: 'DELIVERING' },
        { text: 'REQUEST', value: 'REQUEST' },
        { text: 'CANCEL', value: 'CANCEL' },
      ],
      headers: [
        { text: 'ID', value: 'id', width: '80px' },
        { text: '유저 ID', value: 'user_id', width: '120px' },
        { text: '상품 ID', value: 'prd_id', width: '90px' },
        { text: '상품명', value: 'prd_nm', width: '160px' },
        { text: '교환처', value: 'swap_nm', width: '110px' },
        { text: '판매가', value: 'sale_price', width: '100px' },
        { text: '사용 포인트', value: 'point_price', width: '110px' },
        { text: '상태', value: 'process_state', width: '100px' },
        { text: '구매일', value: 'created_at', width: '150px' },
        { text: '상세', value: 'actions', width: '60px', sortable: false },
      ],
    }
  },
  methods: {
    stateColor(s) {
      if (s === 'DONE') return 'green'
      if (s === 'CANCEL') return 'red'
      if (s === 'DELIVERING') return 'blue'
      return 'grey'
    },
    async load() {
      try {
        this.loading = true
        const r = await prombook.list_buy_history({ ...this.filter })
        this.list = r.buy_history_list || []
        this.total = r.total || 0
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    onSearch() {
      this.filter.page = 1
      this.load()
    },
    async openDetail(item) {
      this.selected = JSON.parse(JSON.stringify(item))
      this.dialog = true
      try {
        const r = await prombook.get_buy_history_detail(item.id)
        if (r && r.buy_history_info) this.selected = r.buy_history_info
      } catch (e) {
        console.error(e)
      }
    },
  },
  mounted() {
    this.load()
  },
}
</script>
